import BaseModel from './base';

class CollaboratorModel extends BaseModel {
	async create(data) {
		return this.post('/', {
			body: data
		});
	}

	async edit(data) {
		return this.patch('/', {
			body: data
		});
	}

	async list({ search }) {
		const params = {};

		if (search) params.searchTerm = search;

		return this.get('', {
			params
		});
	}

	async deleteCollaborator(id) {
		return this.delete(`/${id}`);
	}

	sendInvitation(id) {
		return this.post(`/${id}/send-invitation`);
	}
}

export default new CollaboratorModel('/user/collaborator');
